import { Translation } from "i18n/config";
import { PricingElearningsTranslations } from "./typing";

export const PricingElearningsTexts: Translation<PricingElearningsTranslations> = {
	es: {
		titleSection: "Carga tus cursos, talleres o webinars de la forma más sencilla y fácil posible.",
		uploadAsMuchContentYouWant:
			"Sube tantos contenidos de formación como quieras en todos los perfiles profesionales que tengan la herramienta E-Learning.",
		typeOfElearnings: "Puedes subir Webinars, Talleres y hasta Cursos.",
		clarifyWhoIsTheTarget: "Aclara a quien va dirigido, requisitos y objetivos.",
		useOurTag: "Utiliza nuestros tags para captar más rápido a nuestros usuarios.",
		receiveGeneralInformationOfUsers: "Recibe información general de los usuarios para ponerte en contacto con ellos.",
	},
	en: {
		titleSection: "Upload your courses, workshops or webinars in the simplest and easiest way possible.",
		uploadAsMuchContentYouWant:
			"Upload as much training content as you want in all professional profiles that have the E-Learning tool",
		typeOfElearnings: "You may upload Webinars, Workshops and even courses.",
		clarifyWhoIsTheTarget: "Clarify who is addressed, requirements and objectives.",
		useOurTag: "Use our tags for attracting faster our users.",
		receiveGeneralInformationOfUsers:
			"Receive general information about the users that have visited your E-learning in order to contact them.",
	},
	ca: {
		titleSection: "Carrega els teus cursos, tallers o webinars de la manera més senzilla i fàcil possible.",
		uploadAsMuchContentYouWant:
			"Sube tantos contenidos de formación como quieras en todos los perfiles profesionales que tengan la herramienta E-Learning",
		typeOfElearnings: "Puedes subir Webinars, Talleres y hasta Cursos.",
		clarifyWhoIsTheTarget: "Aclara a quien va dirigido, requisitos y objetivos.",
		useOurTag: "Utiliza nuestros tags para captar más rápido a nuestros usuarios.",
		receiveGeneralInformationOfUsers: "Recibe información general de los usuarios para ponerte en contacto con ellos.",
	},
	pt: {
		titleSection: "Carregue seus cursos, workshops ou webinars da maneira mais simples e fácil possível.",
		uploadAsMuchContentYouWant:
			"Carregue quanto conteúdo de treinamento quiser em todos os perfis profissionais que possuem a ferramenta E-Learning.",
		typeOfElearnings: "Você pode fazer upload de Webinars, Workshops e até Cursos.",
		clarifyWhoIsTheTarget: "Esclarece quem é abordado, requisitos e objetivos.",
		useOurTag: "Use nossas tags para capturar nossos usuários mais rapidamente.",
		receiveGeneralInformationOfUsers: "Receba informações gerais dos usuários para entrar em contato com eles.",
	},
};
